import React from 'react';

export default function CustomUrlComposer({
  label,
  prefix,
  suffix,
  value,
  placeholder,
  onChange
}) {
  return (
    <div className="custom-url-composer-root" style={{ width: "100%", position: "relative", paddingTop: "6px" }}>
      <span
        style={{
          position: "absolute",
          top: 8,
          left: "10px",
          transform: "translateY(-50%)",
          fontSize: "10px",
          color: "rgba(0, 0, 0, 0.6)",
          background: "white",
          padding: "0 4px",
          lineHeight: 1
        }}
      >
        {label}
      </span>
      <div
       style={{
        width: "100%",
        minHeight: "36px",
        border: "1px solid rgba(0, 0, 0, 0.23)",
        borderRadius: "4px",
        background: "#fff",
        display: "flex",
        alignItems: "center",
        gap: "6px",
        padding: "5px 3px 5px 6px",
        overflowX: "auto",
        overflowY: "hidden",
        whiteSpace: "nowrap",
        scrollbarWidth: "thin",
        scrollbarColor: "rgba(0, 0, 0, 0.25) #eef3ff"
      }}
        className="custom-url-composer"
      >
        <span
          style={{
            color: "#2e4a8f",
            whiteSpace: "nowrap",
            flexShrink: 0,
            fontSize: "0.8125rem",
            background: "#eef3ff",
            border: "1px solid #c8d7ff",
            borderRadius: "4px",
            padding: "4px 8px"
          }}
          title={prefix}
        >
          {prefix}
        </span>
        <input
          value={value}
          placeholder={placeholder}
          onChange={onChange}
          style={{
            width: `${Math.max((value || '').length + 1, 12)}ch`,
            minWidth: "12ch",
            maxWidth: "none",
            flex: "0 0 auto",
            border: "none",
            outline: "none",
            background: "#fff",
            borderRadius: "4px",
            border: "1px solid #c8d7ff",
            padding: "5px 8px",
            fontSize: "0.8125rem",
            lineHeight: "1.4375em"
          }}
        />
        {suffix ? (
          <span
            style={{
              color: "#2e4a8f",
              whiteSpace: "nowrap",
              flexShrink: 0,
              fontSize: "0.8125rem",
              background: "#eef3ff",
              border: "1px solid #c8d7ff",
              borderRadius: "4px",
              padding: "4px 8px"
            }}
            title={suffix}
          >
            {suffix}
          </span>
        ) : null}
      </div>
      <style>{`
        .custom-url-composer-root {
          width: 100%;
        }
        @media (max-width: 1100px) {
          .custom-url-composer-root {
            width: 100% !important;
            max-width: 100%;
          }
        }
        .custom-url-composer::-webkit-scrollbar {
          height: 5px;
          background: #fff;
        }
        .custom-url-composer::-webkit-scrollbar-track {
          background: #fff;
        }
        .custom-url-composer::-webkit-scrollbar-thumb {
          background: rgba(0, 0, 0, 0.25);
          border-radius: 8px;
        }
        .custom-url-composer::-webkit-scrollbar-corner {
          background: #fff;
        }
        .custom-url-composer::-webkit-scrollbar-button {
          display: none;
          width: 0;
          height: 0;
        }
      `}</style>
    </div>
  );
}
